import { UserInterfaceV1Type } from '@clientos/types';
import UserInterfaceV1 from './UserInterfaceV1';

export { createNoopUserInterfaceInterface } from './NoopInterface';

let userInterfaceV1: UserInterfaceV1;

export function getUserInterfaceV1(): UserInterfaceV1 {
  return userInterfaceV1;
}

export default async function initializeUserInterfaceV1(): Promise<UserInterfaceV1Type> {
  if (userInterfaceV1) return userInterfaceV1.getInterface();
  userInterfaceV1 = new UserInterfaceV1();

  return userInterfaceV1.getInterface();
}
